<div class="container">
  <div class="container-title">
    <p class="title">{{'medicalConsultations.communication' | translate}}</p>
    <div class="action-read-container">
      <div>
        <img src="../../../../../public/assets/images/notification-red.svg" />
      </div>
      <div (click)="markAllAsRead()">
        <p class="action-read">{{'medicalConsultations.markRead' | translate}}</p>
      </div>
    </div>
  </div>

  <div *ngFor="let notification of data">
    <div [ngClass]="{ 'notification-toberead': notification.toRead, 'notification-read': !notification.toRead }" (click)="markAsRead(notification)">
      <div>
        <img *ngIf="notification.serviceType === 'VideoConsultReadyTelevisitVideo'" src="../../../../../public/assets/images/user-notification.svg" alt="" />
        <img *ngIf="notification.serviceType !== 'VideoConsultReadyTelevisitVideo'" src="../../../../../public/assets/images/mail.svg" alt="" />
      </div>
      <div class="container-texts">
        <div>
          <p class="title-notification">{{ notification.title }}</p>
          <p class="notification-body">{{ notification.text }}</p>
        </div>
        @if (checkLinkValidity(notification)) {
          <div class="container-btns">
            <ds-button
              [text]="(notification?.serviceType === 'TelevisitVideoConsultCompleted'
                        ? ('medicalConsultations.evaluate' | translate)
                        : ('medicalConsultations.enter' | translate))"
              [width]="'small'"
              (click)="openLink(notification)">
            </ds-button>
          </div>
        }
      </div>
      <div (click)="$event.stopPropagation(); deleteNotification(notification)">
        <img class="delete-icon" src="../../../../../public/assets/images/close-notification.svg" alt="close" />
      </div>
    </div>
    <span class="divider"></span>
  </div>
</div>
